// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mic-indication[data-v-16b163fd] {\n  position: absolute;\n  height: 0px;\n  z-index: 2;\n  overflow: hidden;\n  pointer-events: none;\n}\n.volume-svg[data-v-16b163fd] {\n  position: absolute;\n  bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
